import React from "react";
import { MapPin } from "lucide-react";
import { COMPANY } from "@/data/site";

const ServiceAreasSection = () => {
  return (
    <section data-testid="service-areas-section" className="py-20 md:py-32 bg-white">
      <div className="section-container">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="label-xs text-[var(--ct-primary)] mb-3">Wyoming Service Areas</div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-[var(--ct-primary)] tracking-tight" style={{ fontFamily: "Outfit" }}>
              Local movers near you across Wyoming.
            </h2>
            <p className="mt-5 text-[var(--ct-text-muted)] leading-relaxed">
              We provide professional moving services in <strong>Casper, Mills, Evansville, Bar Nunn,
              Glenrock, Laramie, Riverton, and Cheyenne, WY</strong>. Looking for "movers near me" in central
              Wyoming? Crosstown Movers has you covered — from single-item heavy lifting to full residential
              and commercial relocations.
            </p>
            <p className="mt-4 text-sm text-[var(--ct-text-muted)]">
              Based at {COMPANY.address}, our crews reach anywhere in the region quickly and efficiently.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-3">
            {COMPANY.serviceAreas.map((area, i) => (
              <div
                key={area}
                data-testid={`area-${i}`}
                className="group flex items-center gap-3 p-5 rounded-2xl bg-[var(--ct-bg)] border border-[var(--ct-border)] hover:border-[var(--ct-primary)] hover:bg-[var(--ct-primary)] hover:text-white transition-all duration-300"
              >
                <MapPin className="w-5 h-5 text-[var(--ct-secondary)] group-hover:text-[var(--ct-accent)]" />
                <span className="font-semibold">{area}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasSection;
